import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { useWorkspace } from "../../lib/WorkspaceContext";

export default function WorkspaceContextSection() {
  const { t } = useTranslation("common");
  const { current } = useWorkspace();

  const T = (k, o) => t(`settings.profile.${k}`, o);

  if (!current) return null;

  return (
    <section className="border border-zinc-200 rounded-2xl bg-white p-6 mb-6" data-testid="profile-workspace-section">
      <div className="flex items-center gap-3 mb-4">
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-zinc-100 text-zinc-700">
          <Building2 size={18} strokeWidth={1.75} />
        </span>
        <div>
          <h2 className="font-display text-lg font-semibold text-zinc-950">{T("workspace.title")}</h2>
          <p className="text-xs text-zinc-500 mt-0.5 max-w-md">{T("workspace.subtitle")}</p>
        </div>
      </div>

      <div className="divide-y divide-zinc-100">
        <div className="py-3">
          <p className="text-xs text-zinc-500 mb-1">{T("workspace.name_label")}</p>
          <p className="text-sm text-zinc-800" data-testid="profile-workspace-name">
            {current.name}
            {current.is_personal && <span className="text-zinc-400"> ({T("workspace.personal_suffix")})</span>}
          </p>
        </div>
        <div className="py-3">
          <p className="text-xs text-zinc-500 mb-1">{T("workspace.plan_label")}</p>
          <p className="text-sm text-zinc-800" data-testid="profile-workspace-plan">{current.plan}</p>
        </div>
        <div className="py-3">
          <p className="text-xs text-zinc-500 mb-1">{T("workspace.currency_label")}</p>
          <p className="text-sm text-zinc-800" data-testid="profile-workspace-currency">{current.currency}</p>
        </div>
      </div>

      <Link to="/workspaces" data-testid="profile-workspace-manage-link" className="text-sm text-zinc-950 underline">
        {T("workspace.manage_link")}
      </Link>
    </section>
  );
}
